import { FC, memo } from 'react'
import Box from '@mui/material/Box'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import AmexImage from './Amex.png'
import MastercardImage from './Mastercard.png'
import VisaImage from './Visa.png'

const PaymentCardIcon: FC<{ brand: 'visa' | 'amex' | 'mastercard' | 'mc' | string }> = props => {
  const { brand } = props
  if (brand === 'visa') {
    return (
      <Box
        component={'img'}
        src={VisaImage}
        sx={{
          height: 14,
        }}
      />
    )
  }
  if (brand === 'amex') {
    return (
      <Box
        component={'img'}
        src={AmexImage}
        sx={{
          height: 30,
        }}
      />
    )
  }
  if (brand === 'mc' || brand === 'mastercard') {
    return (
      <Box
        component={'img'}
        src={MastercardImage}
        sx={{
          height: 24,
        }}
      />
    )
  }

  return <CreditCardIcon sx={{ fontSize: 24 }} />
}
export default memo(PaymentCardIcon)
